import { render, staticRenderFns } from "./list-reporting-actions.vue?vue&type=template&id=15a673b1"
import script from "./list-reporting-actions.vue?vue&type=script&lang=js"
export * from "./list-reporting-actions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports